import { useState } from "react";
import { getEnquiryResponseDataByPurchaseId, getEnquiryResponseDataByPurchaseIdNew } from "../../services/vendorEnquiryService";

const useEnquiryResponseDetailsByPurchaseId = () => {

    const [responseDetailsList, setResponseDetailsList] = useState([]);
    const [selectedResponse, setSelectedResponse] = useState(null);
    const [selectedResponseID, setSelectedResponseID] = useState(null);

    // Fetch data based on purchase id + compare id
    const fetchEnquiryResponseDetails = async (purchaseID, compareID = 0) => {

        const para = { 
            p_companyid: Number(localStorage.getItem("companyid")),
            p_plantid: 1,
            p_id_purchase: purchaseID,
            p_id_compare: compareID     // <-- added compare id
        };

        try {
            const data = await getEnquiryResponseDataByPurchaseIdNew(para);

            if (data && data.length > 0) {
                setResponseDetailsList(data);

                const found = data.find(r => r.id_purchase === purchaseID);
                if (found) {
                    setSelectedResponse(found);
                    setSelectedResponseID(found.id_purchase);
                }

                return data; 
            }

            return [];

        } catch (error) {
            console.error("Error:", error);
            return [];
        }
    };

    // function you call when user selects a purchase
    const loadEnquiryResponseWhenPurchaseSelected = async (purchaseID, compareID = 0) => {
        const data = await fetchEnquiryResponseDetails(purchaseID, compareID);
        return data;
    };

    return {
        responseDetailsList,
        selectedResponse,
        selectedResponseID,
        loadEnquiryResponseWhenPurchaseSelected
    };
};

export default useEnquiryResponseDetailsByPurchaseId;



// import { useState } from "react";
// import { getEnquiryResponseDataByPurchaseId } from "../../services/vendorEnquiryService";

// const useEnquiryResponseDetailsByPurchaseId = () => {

//     const [responseDetailsList, setResponseDetailsList] = useState([]);
//     const [selectedResponse, setSelectedResponse] = useState(null);
//     const [selectedResponseID, setSelectedResponseID] = useState(null);

//     // Fetch data based on purchase id
//     const fetchEnquiryResponseDetails = async (purchaseID) => {

//         const para = { 
//             p_companyid: localStorage.getItem("companyid"),
//             p_plantid: 1,
//             p_id_purchase: purchaseID
//         };

//         try {
//             const data = await getEnquiryResponseDataByPurchaseId(para);

//             if (data && data.length > 0) {
//                 setResponseDetailsList(data);

                
//                 const found = data.find(r => r.id_purchase === purchaseID);
//                 if (found) {
//                     setSelectedResponse(found);
//                     setSelectedResponseID(found.id_purchase);
//                 }

//                   return data; // <-- return data to caller

//             }
//             return [];

//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     // function you call when user selects an indent
//     const loadEnquiryResponseWhenPurchaseSelected = async (purchaseID) => {
//          const data = await fetchEnquiryResponseDetails(purchaseID);
//     return data;  // <-- return fetched data
//     };

//     return {
//         responseDetailsList,
//         selectedResponse,
//         selectedResponseID,
//         loadEnquiryResponseWhenPurchaseSelected
//     };
// };

// export default useEnquiryResponseDetailsByPurchaseId;
